import React from 'react';
import AdminAuditionSlider from '../AdminAuditionLiveSlider/AdminAuditionSlider';
import AdminAuditionNav from '../AdminAuditionNav/AdminAuditionNav';


const AdminAuditionLive = () => {
    return (
        <>
<AdminAuditionNav/>
        <div className="card card-bg mt-3 py-2">
            <div className="d-flex px-4 pt-3">
                <div className="faTrophy"><i className="fas fa-trophy"></i></div>
                <h4 className="mx-3 text-white p-2">Live Auditions</h4>
            </div>

            <div className="">
                {/* <PendingAuditionSlider /> */}
                <AdminAuditionSlider />
            </div>

        </div>
        </>
    );
};

export default AdminAuditionLive;